import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import TextInputComponent from '~/src/components/common/forms/TextInput/TextInputComponent';

const TwoColumnRow = styled('div')`
  flex-direction: row;
  display: flex;
  padding: 7px 20px;
`;

const CustomColumn = styled('div')`
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  flex: 1;
  padding-left: ${(props) => {
    const propsIndent = props.indent || 0;
    const margin = propsIndent * 20;
    return margin + 'px';
  }};
  text-align: ${(props) => {
    return props.align ?? 'left';
  }};
  align-self: center;
`;

const HorizontalLine = styled('hr')`
  border-top: ${(props) => props.thickness + 'px solid white;'};
  margin: 0;
`;

interface NutriComponentBoxProps {
  leftText?: string;
  unit?: string;
  leftBold?: boolean;
  hrThickness?: number;
  indent?: number;
  inputValue?: string | number;
  handleChange?: any;
  handleBlur?: any;
  name?: string;
  placeholder?: string;
}
export const NutriComponentBox = ({
  leftText,
  unit,
  leftBold = false,
  hrThickness = 1,
  indent = 0,
  inputValue,
  handleChange,
  handleBlur,
  name,
  placeholder,
}: NutriComponentBoxProps): JSX.Element => {
  return (
    <>
      <TwoColumnRow>
        {leftText && (
          <CustomColumn bold={leftBold} indent={indent}>
            {leftText}
          </CustomColumn>
        )}

        <CustomColumn bold={true} align="right">
          {inputValue !== undefined && (
            <TextInputComponent
              inline
              name={name}
              onChange={handleChange}
              onBlur={handleBlur}
              value={inputValue}
              cols={6}
              inlineStyles={{ margin: 0 }}
              placeholder={placeholder}
              height={25}
            />
          )}
          {unit}
        </CustomColumn>
      </TwoColumnRow>
      <HorizontalLine thickness={hrThickness} />
    </>
  );
};
